import { client } from './base'

class UserApi {
  getCourses = () => client.get('/api/courses')
  getUpcomingCourses = () => client.get('/api/upcoming-courses')
  getPastCourses = () => client.get('/api/past-courses')
  getCourseDetail = (id) => client.get(`/api/courses/${id}`)
  uploadCases = (id, payload) => client.post(`/api/courses/${id}/cases`, payload)
  getUploadConfiguration = (id) => client.get(`/api/courses/${id}/upload-configuration`)
  getCases = (id) => client.get(`/api/courses/${id}/cases`)
  getCaseDownloadUrl = (id, caseId) =>
    client.get(`/api/courses/${id}/cases/${caseId}/download`)

  getCasesCopyFolderCommand = (id, date) =>
    client.get(`/api/courses/${id}/cases/copy-folder-command`, {
      params: { date }
    })

  getCaseCopyCommand = (id, caseId) =>
    client.get(`/api/courses/${id}/cases/${caseId}/copy-command`)

  removeCase = (id, caseId) => client.delete(`/api/courses/${id}/cases/${caseId}`)
  editCase = (id, caseId, payload) => client.put(`/api/courses/${id}/cases/${caseId}`, payload)
  editStudentEnabled = (id, studentId) =>
    client.put(`/api/courses/${id}/students/${studentId}/enabled`)

  editStudentPreAccess = (id, studentId) =>
    client.put(`/api/courses/${id}/students/${studentId}/pre-access`)
}

export default new UserApi()
